<template>
	<div class="carousel-container">

		<swiper
				class="carousel-section-swiper"
				v-if="slides?.data?.images?.length > 0"
				:pagination="true"
				:loop="LoopOption"
				:autoplay="AutoPlayOptions"
				:modules="modules"
				:navigation="true"
				:autoHeight="true"
		>
			<swiper-slide v-for="(slide, index) in slides.data.images" :key="index">

				<seo-image :data="slide.background" :alt="slide.title"/>

				<div class="slide-content-bg">
					<div class="slide-content" :class="slides.data?.type === CarouselTypeEnum.CAPTION ? 'slide-content__caption' : 'slide-content__search'">
						<div>
							<h2 class="carousel-title" :style="{color: slide.title_color}">{{ slide.title }}</h2>
							<p class="carousel-lead" v-if="slide.lead" :style="{color: slide.title_color}" v-html="slide.lead"></p>
							<div class="carousel-link-buttons" v-if="slide?.button?.title || slide?.button2?.title">
								<a class="carousel-link-button" :href="slide.button.url">
									<button-unit
											:style="{
											color: slide.button.color,
											backgroundColor: slide.button.background
										 }"
											:options="{
											shape: ButtonUnitShape.ROUNDED,
											text: slide.button.title,
											bgColor: '',
											textColor: '',
										}"
									/>
								</a>
								<a class="carousel-link-button" v-if="slide.button2?.url" :href="slide.button2.url">
									<button-unit
											:style="{
										color: slide.button2.color,
										backgroundColor: slide.button2.background
									 }"
											:options="{
										shape: ButtonUnitShape.ROUNDED,
										text: slide.button2.title,
										bgColor: '',
										textColor: '',
									}"
									/>
								</a>
							</div>
						</div>

					</div>
				</div>
			</swiper-slide>
		</swiper>

		<div v-if="slides.data.search && slides.data?.type === CarouselTypeEnum.SEARCH" class="container carousel-search-bar-container">
			<search-bar-multi-key :search-design="slides.data.search"/>
		</div>

	</div>
</template>

<script lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Autoplay, Navigation, Pagination} from 'swiper';
import {defineComponent, PropType} from 'vue';
import ButtonUnit from './Units/ButtonUnit.vue';
import {ButtonUnitShape} from "./Units/Interfaces/ButtonUnitShape";
import {CarouselInterface} from "./Interfaces/CarouselSection/CarouselInterface";
import SearchBarMultiKey from "./SearchBar/SeachBarMutliKeyword.vue";
import {CarouselTypeEnum} from "../../AdminApp/Views/PageModule/Enums/CarouselTypeEnum";
import {useSearchDataStore} from "@WebApp/Stores/SearchData/SearchDataStore";
import SeoImage from "./SeoImage.vue";


export default defineComponent({
	name: "CarouselSection",
	components: {
		SeoImage,
		SearchBarMultiKey,
		ButtonUnit,
		Swiper,
		SwiperSlide,
	},
	props: {
		slides: {
			type: Object as PropType<CarouselInterface>,
			default: {},
			required: true,
		},
	},
	setup() {
		return {
			modules: [Navigation, Pagination, Autoplay],
			searchDataStore: useSearchDataStore()
		};
	},
	computed: {
		CarouselTypeEnum() {
			return CarouselTypeEnum
		},
		ButtonUnitShape() {
			return ButtonUnitShape
		},
		SlideCount() {
			return this.slides.data.images.length;
		},
		AutoPlayOptions() {
			const delay = this.slides.data.delay ?? 7000;
			return this.SlideCount > 1
					? {delay, disableOnInteraction: false}
					: false;
		},
		LoopOption() {
			return this.SlideCount > 1;
		},
		isSearch(): boolean {
			return this.slides.data.type === CarouselTypeEnum.SEARCH;
		}
	},
	watch: {
		isSearch() {
			if (this.isSearch) {
				this.searchDataStore.getSearchDataLoad(['categories', 'counties', 'cities', 'countySeats', 'bpDistricts', 'countries']);
			}
		}
	}
});
</script>

<style lang="scss" scoped>

</style>
